const config = {
  defaultPage: '/dashboard',
  workspace: {
    paymentInfoEnable: true,
    downloadCSVEnable: true,
    editable: true,
    addWorksapceEnable: true,
    addMemberEnable: true,
    maxMemberEditable: true,
    expiredAtEditable: true,
    statusEditable: true,
  },
}

export default config
